import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, Users, HardHat, Briefcase } from 'lucide-react';
const reasons = [{
  icon: Briefcase,
  title: '40 años de experiencia',
  description: 'Trayectoria comprobable en el mercado chileno.'
}, {
  icon: HardHat,
  title: 'Especialistas corporativos',
  description: 'Foco exclusivo en oficinas y retail, no vivienda.'
}, {
  icon: Clock,
  title: 'Cumplimiento de plazos',
  description: 'El tiempo es crítico para tu operación.'
}, {
  icon: Users,
  title: 'Coordinación integral',
  description: 'Gestión completa de obra y especialidades.'
}, {
  icon: ShieldCheck,
  title: 'Enfoque operativo',
  description: 'Construimos pensando en el uso diario.'
}];
export function WhyForax() {
  return <section className="relative py-16 sm:py-24 overflow-hidden" data-id="element-533">
      {/* Dynamic Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-indigo-900 to-blue-950" data-id="element-534" />
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] mix-blend-overlay" data-id="element-535" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-536">
        <div className="mb-12 sm:mb-20 text-center" data-id="element-537">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl md:text-5xl" data-id="element-538">
            ¿Por qué Forax?
          </h2>
          <p className="mt-4 text-lg sm:text-xl text-blue-200" data-id="element-539">
            Solidez y confianza para tu inversión.
          </p>
        </div>

        {/*
          Mobile: Horizontal Scroll with Snap
          Desktop: Grid Layout
         */}
        <div className="
          flex overflow-x-auto snap-x snap-mandatory gap-4 pb-8 -mx-4 px-4
          [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']
          md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6 md:overflow-visible md:pb-0 md:px-0 md:mx-0
        " data-id="element-540">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="
                flex-shrink-0 w-[85vw] snap-center
                group flex flex-col items-start rounded-2xl sm:rounded-3xl bg-white/5 p-6 sm:p-8 backdrop-blur-md border border-white/10 transition-all hover:bg-white/10 hover:border-white/20 hover:shadow-xl
                md:w-auto
              " data-id="element-541">
              <div className="mb-4 sm:mb-6 rounded-2xl bg-blue-500/20 p-3 text-blue-300 group-hover:text-white group-hover:bg-blue-500 transition-colors" data-id="element-542">
                <reason.icon className="h-7 w-7 sm:h-8 sm:w-8" data-id="element-543" />
              </div>
              <h3 className="mb-2 sm:mb-3 text-lg sm:text-xl font-bold text-white" data-id="element-544">
                {reason.title}
              </h3>
              <p className="text-blue-100/80 leading-relaxed text-sm sm:text-base" data-id="element-545">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}